import React, { useEffect, useState } from 'react';
import Listingheader from 'routes/home/components/common/ListingheaderV2';
import makeRequest from 'utils/makeRequest';
import { UNIFIED_FEED_DOMAIN_GLOBAL } from 'constants';
import {
  getAQIClassName,
  getSpecificDataForPassedKeys,
} from 'routes/newslisting/layouts/config/AqiConfig';
import s from './Rectangular.scss';
import RectangularTabInner from '../../components_v2/common/RectangularTabInner/RectangularTabInner';

const RectangularTabs = ({
  sectionData,
  className,
  name,
  isbackgroundNeeded,
  geoDataUrl,
}) => {
  const [items, setItems] = useState([]);
  const [geocity, setGeocity] = useState('');
  const getPollutantData = geoinfo => {
    makeRequest
      .get(
        `${UNIFIED_FEED_DOMAIN_GLOBAL}/ufs-utility/utility/api/v1/aqi/get/city/detail?city=${
          typeof geoinfo?.city === 'string' && geoinfo?.city
            ? geoinfo?.city.toLowerCase()
            : 'new-delhi'
        }&pc=toi&pfm=web&client=toi&fv=1000`,
      )
      .then(res => {
        if (res && res.data) {
          const extractedNeededData = getSpecificDataForPassedKeys(
            res?.data.data?.componentMap,
            ['pm25', 'pm10', 'co', 'so2', 'no2', 'o3'],
          );
          setItems(
            extractedNeededData &&
            Array.isArray(extractedNeededData) &&
            extractedNeededData.length > 0
              ? extractedNeededData.map(obj => ({
                  title: obj.name,
                  subtitle:
                    obj?.sensorName === 'pm25'
                      ? 'PM2.5'
                      : obj?.sensorName?.toUpperCase(),
                  classes: getAQIClassName(obj.sensorName, obj.sensorData),
                  value: obj.sensorData,
                  unit: obj.sensorUnit,
                }))
              : [],
          );
        }
      });
  };

  useEffect(() => {
    if (geoDataUrl) {
      makeRequest.get(geoDataUrl).then(res => {
        const { data } = res;
        setGeocity(data.city || 'new-delhi');
        getPollutantData(data);
      });
    }
  }, []);

  return (
    <div className={s.rec_tab_inner}>
      {name && (
        <Listingheader
          headingname={
            geoDataUrl ? `Major AQI Pollutants in ${geocity} Today` : name
          }
        />
      )}
      <div className={`${s.weight_category} ${className ? s[className] : ''}`}>
        {sectionData &&
          Array.isArray(sectionData) &&
          sectionData.length > 0 &&
          sectionData.map(item => (
            <RectangularTabInner
              title={item.title}
              className={className}
              subtitle={item.subtitle}
              classes={item.classes || item.class}
              desc={item.desc}
              value={item.value}
              unit={item.unit}
              isbackgroundNeeded={isbackgroundNeeded}
            />
          ))}
        {items &&
          Array.isArray(items) &&
          items.length > 0 &&
          items.map(item => (
            <RectangularTabInner
              title={item.title}
              className={className}
              subtitle={item.subtitle}
              classes={item.classes || item.class}
              desc={item.desc}
              value={item.value}
              unit={item.unit}
              isbackgroundNeeded={isbackgroundNeeded}
            />
          ))}
      </div>
    </div>
  );
};

export default RectangularTabs;
